/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-02-24 09:31:16
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-02-25 11:22:53
 */
import React from 'react'
//引入依赖
import 'video.js/dist/video-js.css'
import 'videojs-flash'
import videojs from 'video.js'
import './index.css'
import { Link } from 'react-router-dom'

const url = [
    {
        url: "rtmp://58.200.131.2:1935/livetv/hunantv",
        name: "湖南卫视"
    },
    {
        url: "rtmp://202.69.69.180:443/webcast/bshdlive-pc",
        name: "香港财经"
    },
    {
        url: "rtmp://mobliestream.c3tv.com:554/live/goodtv.sdp",
        name: "韩国GoodTV"
    },
    {
        url: "rtmp://media3.sinovision.net:1935/live/livestream",
        name: "美国中文电视"
    }, {
        url: "rtmp://58.200.131.2:1935/livetv/hunantv",
        name: "湖南卫视"
    },
    {
        url: "rtmp://202.69.69.180:443/webcast/bshdlive-pc",
        name: "香港财经"
    },
    {
        url: "rtmp://mobliestream.c3tv.com:554/live/goodtv.sdp",
        name: "韩国GoodTV"
    },
    {
        url: "rtmp://media3.sinovision.net:1935/live/livestream",
        name: "美国中文电视"
    }
]
class OnlineClass extends React.Component {
    state = {
        nowPlay: ""
    }
    componentDidMount() {

    }
    handleClick(item) {

    }
    render() {

        return (
            <div className='onlineclass-main'>
                直播间列表页
                <div className='onlineclass-content-list'>
                    {
                        url.map((room, index) => {
                            return (
                                <Link  className='onlineclass-roomentity' to={{
                                    pathname: `/OnlineClass/${index}`,
                                    // param:room
                                }} target='_blank'>
                                    <div>
                                        {room.name}
                                    </div>
                                </Link>
                            )
                        })
                    }
                </div>

            </div >
        )
    }

}

export default OnlineClass